import { render, staticRenderFns } from "./DictionaryCrud.vue?vue&type=template&id=5c69ae1d&scoped=true&"
import script from "./DictionaryCrud.vue?vue&type=script&lang=js&"
export * from "./DictionaryCrud.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryCrud.vue?vue&type=style&index=0&id=5c69ae1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c69ae1d",
  null
  
)

export default component.exports